<template>
  <div class="title-block">
    Êtes-vous sûr de vouloir archiver la campagne
    <span class="primary-color bold" v-text="data.name" />
    ?
  </div>
  <p class="under-text">
    Pour rappel, l’archivage de votre campagne n’est pas définitif, vous pourrez
    la restaurer à tout moment depuis votre page organisation.
  </p>
  <div class="btn-container">
    <Button
      class="secondary outline"
      label="Annuler l’opération"
      @click="emits('close')"
    />
    <Button
      class="primary"
      label="Archiver la campagne"
      :loading="state.btnIsLoading"
      @click="archive()"
    />
  </div>
</template>

<script setup>
import { reactive } from "vue";
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";
import { getError } from "@/composables/error.js";
import { useCampaignStore } from "@/stores/campaign.js";
import ToastContent from "@/components/global/ToastContent.vue";

const emits = defineEmits(["close", "confirm"]);

const campaignStore = useCampaignStore();

const route = useRoute();

const toast = useToast();

const state = reactive({
  btnIsLoading: false,
});

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

async function archive() {
  state.btnIsLoading = true;

  const resp = await campaignStore.archiveCampaign(
    route.params.companyId,
    route.params.spaceId,
    props.data.campaign_id
  );

  if (!resp.code) {
    toast.success({
      component: ToastContent,
      props: {
        text: "Votre campagne a bien été archivée. Vous pouvez la restaurer à tout moment depuis votre <span class='bold'>Page Organisation</span>.",
      },
      closeOnClick: false,
    });
  } else {
    toast.error(getError(resp.key));
  }

  emits("confirm");

  state.btnIsLoading = false;
}
</script>
